import { COUNTRIES, ECountry, type ICountry } from "~application/constants/country.constant.ts";

export enum ELocale {
  FRENCH = "fr-FR",
  ENGLISH = "en-US",
}

export interface ILocaleCountry {
  country: ECountry;
  locale: ELocale;
}

export const INITIAL_LOCALE = ELocale.FRENCH;
export const SUPPORTED_LOCALES = Object.values(ELocale);

export const CountryLocaleMapping: ReadonlyArray<ILocaleCountry> = Object.freeze([
  {
    country: ECountry.FRANCE,
    locale: ELocale.FRENCH,
  },
  {
    country: ECountry.UNITED_KINGDOM,
    locale: ELocale.ENGLISH,
  },
]);

export function findLocaleByCountry(country: ECountry) {
  return CountryLocaleMapping.find((cl) => cl.country === country)?.locale ?? ELocale.ENGLISH;
}

export function localeToCountry(locale: ELocale, fallback: ICountry = COUNTRIES[ECountry.FRANCE]): ICountry {
  const countryKey = CountryLocaleMapping.find((countryLocale) => countryLocale.locale === locale)?.country;

  if (!countryKey) {
    return fallback;
  }

  return COUNTRIES[countryKey];
}

export const getFlagEmojiByLocale = (locale: ELocale) => {
  const localeCountry = CountryLocaleMapping.find((l) => l.locale === locale);

  if (!localeCountry) {
    return undefined;
  }

  const country = COUNTRIES[localeCountry.country];

  const codePoints = country.code
    .toUpperCase()
    .split("")
    .map((char) => 127397 + char.charCodeAt(0));
  return String.fromCodePoint(...codePoints);
};
